import { useState } from "react"
import EllipsisMenu from "../../../../components/EllipsisMenu/EllipsisMenu"
import FileIcon from "../../../../media/FileIcon"
import { StagedWorkflowFileProps } from "./StagedWorkflow.types"
import "./StagedWorkflowFile.css"
import TickIcon from "../../../../media/TickIcon"

const StagedWorkflowFile = ({ 
    filename,
    pipeId,
    date,
    ellipsisMenu,
    isChecked,
    onCheck,
    isSelected,
    onSelect,
    onDoubleClick,
    disabled = false
  }: StagedWorkflowFileProps) => {

  const [showMenu, setShowMenu] = useState<boolean>(false)

  return (
    <div
      className={`scope-workflow-file-container ${isSelected ? "scope-workflow-file-selected" : ""} ${disabled ? "scope-workflow-disabled" : ""}`}
      onClick={disabled ? () => {} : onSelect}
      onDoubleClick={disabled ? () => {} : onDoubleClick}
    >

      <div className={`scope-workflow-first-column ${disabled ? "scope-workflow-disabled" : ""}`}>
        <div
          className={`scope-workflow-check-box ${isChecked ? "scope-workflow-selected" : ""} ${disabled ? "scope-workflow-disabled" : ""}`}
          onClick={disabled ? () => {} : onCheck}
        >
          {isChecked && (
            <TickIcon />
          )}
        </div>
        <div className="pipe-id-container">
          <FileIcon />
          <p>{filename}</p>
        </div>
      </div>

      <p>{pipeId}</p>
      <p>{date}</p>
      <div className={`ellipsis-menu-container ${disabled ? "scope-workflow-disabled" : ""}`}>
        <EllipsisMenu
          ellipsisMenu={{
            items: ellipsisMenu,
            showMenu: showMenu,
            onClick: disabled ? () => {} : () => setShowMenu(true),
            onHide: () => setShowMenu(false),
          }}
        />
      </div>
    </div>
  )
}

export default StagedWorkflowFile